import React, { useEffect, useRef, useState } from 'react'
import { useIonViewDidLeave } from '@ionic/react'
import { observer } from 'mobx-react'
import { storeMobx, discountMobx } from 'restaurant'
import { format } from '@dt/fe-utils'
import { map } from '@dt/fe-utils/dist/lodash'
import { Icon } from '@cps'
import './index.scss'

interface IProps {
  type?: string;
  onChange: (isFull: boolean) => void;
}

let _list: {
  type: string;
  value: string;
}[] = []

const MenuNoticeScroll: React.FC<IProps> = (props) => {
  const { onChange, type } = props
  const { noticeConfig } = storeMobx.info
  const show = noticeConfig?.showCustom?.content || (noticeConfig?.showMktInfo && discountMobx.activities?.length) || noticeConfig?.showStoreInfo
  let inter = useRef(null as any)
  const [style, setStyle] = useState({})
  const [list, setList] = useState([])

  const handleScrollUp = () => {
    if (_list.length <= 1) return
    _list.push(_list[0])
    setList(_list)
    setStyle({
      marginTop: type === 'waterfall' ? '-40px' : '-30px',
      transition: 'all 0.8s ease-in-out',
    })
    setTimeout(() => {
      _list.shift()
      setList(_list)
      setStyle({
        marginTop: '0',
        transition: 'none',
      })
    }, 500)
  }

  useEffect(() => {
    const activities = storeMobx.info.noticeConfig?.showMktInfo ? map(discountMobx.activities, item => ({ type: 'mkt', value: item.activityName })) : []
    _list = [
      {
        type: 'custom',
        value: storeMobx.info.noticeConfig?.showCustom?.content
      },
      ...activities
    ].filter(item => !!item.value)
    if (!_list.length) {
      const storeSaleTime = format.toSaleTime(storeMobx.info?.saleTime, bo === 'cn' ? '24' : '12')
      const infos = [`${storeMobx.info?.address}${storeMobx.info?.addressDetails}`, storeMobx.info?.tel, ...storeSaleTime]
      _list = [{
        type: 'store',
        value: infos.filter(item => !!item).join(bo === 'cn' ? '；' : ';')
      }]
      setList(_list)
    } else {
      setList(_list)
      inter && clearInterval(inter.current)
      inter.current = setInterval(handleScrollUp, 3000)
    }
  }, [discountMobx.activities, storeMobx.info])

  useEffect(() => {
    return () => {
      _list = []
      inter && clearInterval(inter.current)
    }
  }, [])

  useIonViewDidLeave(() => {
    onChange(false)
  }, [])

  if (!show) return null

  return (
    <div className={`menu-notice-scroll ${type || ''}`}>
      <div className='menu-notice-content'>
        <div style={style}>
          {list?.map((item, index) => {
            return (
              <div key={index} className='menu-notice-scroll-item'>
                {['custom', 'mkt'].includes(item.type) && <Icon name={item.type === 'custom' ? 'a-huabanbeifen3' : 'huaban4'} />}
                {item.value}
              </div>
            )
          })}
        </div>
      </div>
      <div className='menu-notice-fold' onClick={() => onChange(true)}>
        <Icon name='chevron-down' />
      </div>
    </div>
  )
}

export default observer(MenuNoticeScroll)
